var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.11953 1.63516C7.4971 0.933959 8.5029 0.93396 8.88047 1.63516L14.2063 11.5259C14.565 12.1921 14.0825 13 13.3258 13H2.67422C1.91754 13 1.43501 12.1921 1.79375 11.5259L7.11953 1.63516Z",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5.5L8 7.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 10,
  r: 1,
  fill: "currentColor"
})));
export default SvgAlertLarge;